// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.L_YTIqW3eIgI_TWzFqns{justify-content:center;align-items:center;height:200px;font-size:14px;font-weight:500;display:flex}.DI59dmQUpOkf4kYhutRZ{border-bottom:1px solid var(--border-neutral-default);padding:8px 4px}.G78ZdYkeqHs2QyJTtiO5{color:var(--light-blue-60)}.yvo40cY4quQkIsBjJPQ0 [aria-label=DropdownList_NoResult]{padding:12px 0;font-size:13px}._GCN2cbzPmkg5zxkHp41{flex-direction:column;gap:6px;margin-top:14px;display:flex}.fJD6FfTiHjQNmKeRZnML{max-height:696px;display:flex;position:relative}.YlSvFhgx8mUF3uQc2QYf{width:calc(100% - 4px);height:100%}.d4DgEX4_DIs8JpQ5mZW8{pointer-events:none}.d4DgEX4_DIs8JpQ5mZW8 tbody{opacity:.4}.d4DgEX4_DIs8JpQ5mZW8 .T5JbhthBcoWjWvI21Hbo svg{animation:1s linear infinite wUOpQ5iPKAOsvjg0E4VD}.JRy_a1nOA8cyNNzv7q5D{align-items:center;min-height:56px;display:flex}.Kv_VTUf6cc6_9F1nIbV_{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noListsWrap": `L_YTIqW3eIgI_TWzFqns`,
	"dropdownButtonWrapper": `DI59dmQUpOkf4kYhutRZ`,
	"selectAllButton": `G78ZdYkeqHs2QyJTtiO5`,
	"dropdownList": `yvo40cY4quQkIsBjJPQ0`,
	"listsViewWrap": `_GCN2cbzPmkg5zxkHp41`,
	"table": `fJD6FfTiHjQNmKeRZnML`,
	"viewScrollClassName": `YlSvFhgx8mUF3uQc2QYf`,
	"loading": `d4DgEX4_DIs8JpQ5mZW8`,
	"headerIcon": `T5JbhthBcoWjWvI21Hbo`,
	"rotation": `wUOpQ5iPKAOsvjg0E4VD`,
	"row": `JRy_a1nOA8cyNNzv7q5D`,
	"cellWrapper": `Kv_VTUf6cc6_9F1nIbV_`
};
export default ___CSS_LOADER_EXPORT___;
